import {
  IonBadge,
  IonDatetime,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
} from '@ionic/react';
import { ScalesIcon } from '@phosphor-icons/react';
import React from 'react';

import { usePesajeHelper } from '../../../hooks/Alimentacion-Pesaje/usePesajeHelper';
import Button from '../../UI/Button';
import FormHeader from '../../UI/FormHeader';
import FormItem from '../../UI/FormItem';
import Spinner from '../../UI/Spinner';
import './Pesaje.scss';
import { PesajeProps } from './types';

const Pesaje: React.FC<PesajeProps> = (props) => {
  const {
    isLoading,
    historialConVariaciones,
    today,
    control,
    errors,
    handleSubmit,
    enterRef,
    handleEnter,
    onSubmit,
    handleNavigate,
    formatFecha,
    formatVariacion,
    getVariacionColor,
    view,
  } = usePesajeHelper(props);

  if (!view) {
    return (
      <div className="pesaje">
        <FormHeader
          icon={<ScalesIcon />}
          title="Pesaje"
          subtitle={`Registrá el pesaje de ${props.nombre}`}
        />
        <div className="ion-padding">
          <Button marginBottom={false} onClick={() => handleNavigate('agregar')}>
            Agregar peso
          </Button>
          <Button noMarginTop onClick={() => handleNavigate('historial')}>
            Historial de pesaje
          </Button>
        </div>
      </div>
    );
  }

  if (view === 'agregar') {
    return (
      <div className="pesaje">
        <FormHeader
          icon={<ScalesIcon />}
          title="Agregar peso"
          subtitle={`Registrá el peso de ${props.nombre}`}
        />
        <form
          onSubmit={handleSubmit(onSubmit)}
          onKeyUp={handleEnter}
          className="ion-padding-horizontal"
        >
          <FormItem
            name="peso"
            control={control}
            errors={errors}
            rules={{ required: 'Por favor, ingresa el peso' }}
            render={({ onChange, name, value }) => (
              <IonItem>
                <IonLabel position="floating">Peso (kg)</IonLabel>
                <IonInput
                  type="number"
                  name={name}
                  value={value}
                  inputMode="decimal"
                  onIonChange={(e) => onChange(parseFloat(e.detail.value!) || null)}
                />
              </IonItem>
            )}
          />

          <FormItem
            name="fecha_pesaje"
            control={control}
            errors={errors}
            rules={{ required: 'Por favor, ingresa la fecha' }}
            render={({ onChange, value }) => (
              <IonItem>
                <IonLabel position="floating">Fecha de pesaje</IonLabel>
                <IonDatetime
                  value={value}
                  onIonChange={(e) => onChange(e.detail.value)}
                  displayFormat="DD-MM-YYYY"
                  max={today}
                  doneText="Confirmar"
                  cancelText="Cancelar"
                />
              </IonItem>
            )}
          />

          <div className="ion-margin-top">
            <Button ref={enterRef} type="submit" disabled={isLoading}>
              {isLoading ? <Spinner color="light" /> : 'Agregar peso'}
            </Button>
          </div>
        </form>
      </div>
    );
  }

  return (
    <div className="pesaje">
      <HistorialList
        historial={historialConVariaciones}
        formatFecha={formatFecha}
        formatVariacion={formatVariacion}
        getVariacionColor={getVariacionColor}
        nombreMascota={props.nombre}
      />
    </div>
  );
};

interface HistorialListProps {
  historial: Array<{
    peso: number;
    fecha_pesaje: string;
    variacion: number | null;
  }>;
  formatFecha: (fecha: string) => string;
  formatVariacion: (variacion: number) => string;
  getVariacionColor: (variacion: number) => string;
  nombreMascota: string;
}

const HistorialList: React.FC<HistorialListProps> = ({
  historial,
  formatFecha,
  formatVariacion,
  getVariacionColor,
  nombreMascota,
}) => {
  if (!historial.length) {
    return (
      <div className="pesaje__empty-state">
        <div className="pesaje__empty-icon">
          <ScalesIcon weight="regular" />
        </div>
        <h3 className="pesaje__empty-title">Sin registros de peso</h3>
        <p className="pesaje__empty-description">
          Aún no hay registros de peso para {nombreMascota}.
        </p>
      </div>
    );
  }

  return (
    <IonList>
      {historial.map(({ peso, fecha_pesaje, variacion }, index) => (
        <IonItem key={`${fecha_pesaje}-${peso}-${index}`}>
          <IonLabel>
            <h2>{formatFecha(fecha_pesaje)}</h2>
            <p>{peso} kg</p>
          </IonLabel>
          {variacion !== null && (
            <IonBadge
              mode="ios"
              color={getVariacionColor(variacion)}
              className="pesaje__variacion-badge"
            >
              {formatVariacion(variacion)} kg
            </IonBadge>
          )}
        </IonItem>
      ))}
    </IonList>
  );
};

export default Pesaje;
